import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
}

const PurchasePlannedDate: React.FC<Props> = (props) => {
    return (
        <Section title="Размещение извещения">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-col">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Планируемая дата размещения{' '}
                        </label>

                        <input
                            type="date"
                            className={`form-input user-input-placeholder w-[200px]`}
                            value={
                                props.purchase?.publication_planned_date ?? ''
                            }
                            style={{
                                colorScheme:
                                    props.theme == 'dark' ? 'dark' : 'light',
                            }}
                        />
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchasePlannedDate
